// extracted by mini-css-extract-plugin
module.exports = {"float-button":"FloatButton_float-button__cZKBy","float-button__hide":"FloatButton_float-button__hide__6AfZ0"};